export const maxButtonPanelWidth = 258;

export const HEADER_BREADCRUMBS_COMPACT_BEGIN_MARK_KEY = 'HEADER_BREADCRUMBS_COMPACT_BEGIN_MARK';
export const HEADER_BREADCRUMBS_COMPACT_END_MARK_KEY = 'HEADER_BREADCRUMBS_COMPACT_END_MARK';

export const HEADER_ACTIONS_COMPACT_BEGIN_MARK_KEY = 'HEADER_ACTIONS_COMPACT_BEGIN_MARK';
export const HEADER_ACTIONS_COMPACT_END_MARK_KEY = 'HEADER_ACTIONS_COMPACT_END_MARK';
